import { createFileRoute, notFound } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo";
import { faqSchema } from "@/components/FAQAccordion";
import { getGuide, getRelatedGuides } from "@/lib/guides";
import { GuidePageTemplate } from "@/components/GuidePageTemplate";
import { WOODSEER_AUTHOR } from "@/lib/blog-author";

export const Route = createFileRoute("/guide/$slug")({
  loader: ({ params }) => {
    const guide = getGuide(params.slug);
    if (!guide) throw notFound();
    return { guide, related: getRelatedGuides(params.slug) };
  },
  head: ({ params, loaderData }) => {
    const g = loaderData?.guide;
    if (!g) return {};
    return seoHead({
      path: `/guide/${params.slug}`,
      title: g.metaTitle,
      description: g.metaDescription,
      ogType: "article",
      breadcrumbs: [
        { name: "Home", path: "/" },
        { name: "Motorist Help", path: "/motorist-help" },
        { name: g.title, path: `/guide/${params.slug}` },
      ],
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          headline: g.title,
          description: g.metaDescription,
          datePublished: g.publishedAt,
          dateModified: g.publishedAt,
          author: { "@type": "Organization", name: WOODSEER_AUTHOR.name, url: WOODSEER_AUTHOR.url },
          publisher: { "@id": "https://woodseerautos.co.uk/#business" },
          mainEntityOfPage: `https://woodseerautos.co.uk/guide/${params.slug}`,
          articleSection: g.category,
        },
        faqSchema(g.faqs) as Record<string, unknown>,
      ],
    });
  },
  component: GuidePage,
});

function GuidePage() {
  const { guide, related } = Route.useLoaderData();
  return <GuidePageTemplate guide={guide} related={related} />;
}
